import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Role } from 'src/app/assabil-kernel/models/entities/master-data/role-entity';
import { Person } from 'src/app/assabil-kernel/models/entities/master-data/person-entity';
import { Branch } from 'src/app/assabil-kernel/models/entities/control-tables/branch-entity';
import { Asset } from 'src/app/assabil-kernel/models/entities/master-data/asset';



export class AssetInventory extends BaseEntity {

  assetInventoryCode  : string;
  role                : Role   = new Role();
  person              : Person = new Person();
  theDate             : Date;	
  closingDate         : Date;
  branch              : Branch = new Branch();

  // Transient
  assets              : Asset[];
  totalBranch         : number;
  alreadyInventoried  : number;

  constructor() {
    super();

  }
}

	
